export interface DefaultLocationSuggestion {
  type:
    | 'region'
    | 'subregion'
    | 'propertyType'
    | 'property'
    | 'mapping'
    | 'keyword';
  name: string;
  sublabel?: string;
}

function propertyTypesLast(
  suggestions: DefaultLocationSuggestion[],
): DefaultLocationSuggestion[] {
  return [...suggestions].sort((a, b) => {
    if (a.type === 'propertyType' && b.type !== 'propertyType') {
      return 1;
    }
    if (a.type !== 'propertyType' && b.type === 'propertyType') {
      return -1;
    }
    return 0;
  });
}

export const DEFAULT_LOCATION_EMPTY_STATE_SUGGESTIONS: DefaultLocationSuggestion[] =
  propertyTypesLast([
    {
      type: 'subregion',
      name: 'Ayia Napa',
      sublabel: 'Cyprus',
    },
    {
      type: 'subregion',
      name: 'Fig Tree Bay',
      sublabel: 'Cyprus',
    },
    {
      type: 'subregion',
      name: 'Nissi Beach',
      sublabel: 'Cyprus',
    },
    {
      type: 'subregion',
      name: 'Pernera',
      sublabel: 'Cyprus',
    },
    {
      type: 'subregion',
      name: 'Kapparis',
      sublabel: 'Cyprus',
    },
    {
      type: 'subregion',
      name: 'Ayia Thekla',
      sublabel: 'Cyprus',
    },
    {
      type: 'propertyType',
      name: 'Apartment',
      sublabel: 'Property type',
    },
    {
      type: 'propertyType',
      name: 'Villa',
      sublabel: 'Property type',
    },
  ]);
